import { validation } from '@shared/utils/validation.types';
import { REGEXES } from '@shared/constants/validation.constants';
import * as objectUtils from './object.utils';

export const validate = (schema, data, { convert, ...yupOptions } = {
    convert: false,
    abortEarly: false,
}) => (
    schema.validate(data, yupOptions)
        .catch(error => Promise.reject(convert ? convertYupErrorToMessagesObject(error) : error))
);

export const getInnerError = error => (error.inner.length ? error.inner : [error]);

export const convertYupErrorToObject = (error, initialState = {}) => getInnerError(error)
    .reduce((obj, field) => objectUtils.setIn(field.path, true, obj), initialState);

export const convertYupErrorToMessagesObject = (error, initialState = {}) => getInnerError(error)
    .reduce((obj, field) => objectUtils.setIn(field.path, field.message, obj), initialState);

export const validateEmail: validation = (text: string): boolean => REGEXES.EMAIL.test(text);
